function addSampleToCart(variantId, productTitle) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
      properties: {
        Sample: 'yes', // We'll detect this in the cart template to set price = 99 kr
      },
    }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Error adding sample to cart');
      }
      return response.json();
    })
    .then(() => {
      alert(`${productTitle} er nu tilføjet som prøvevare til 99 kr!`);
      window.location.href = '/cart'; // Redirect to the cart page
    })
    .catch((error) => {
      console.error('Error:', error);
      alert('Kunne ikke tilføje prøvevaren til kurven. Prøv venligst igen.');
    });
}
